<div class="branding-container">

  <a routerLink="/" class="branding-link">
    <span *ngIf="showWordmark; else logoImg" class="branding-wordmark" data-test="brand-wordmark">{{ brandName }}</span>
    <ng-template #logoImg>
      <img
        [src]="companyLogo"
        class="branding-logo"
        [alt]="user?.companyName || 'Company logo'"
      />
    </ng-template>
  </a>

  <label
    *ngIf="user?.role === 'CompanyOwner'"
    class="logo-edit-button"
    matTooltip="Update company logo"
  >
    <i-tabler name="refresh" class="icon-18"></i-tabler>

    <input
      type="file"
      accept="image/png,image/jpeg,image/jpg,image/svg+xml"
      hidden
      (change)="onLogoSelected($event)"
    />
  </label>

</div>